import View from "../components/MD/View";

const TermsAndConditionsPage = ({}) => {
   //usa https://magic.reactjs.net/htmltojsx.htm per convertire html da termly in jsx
   return (
      <View fullWidth centerCenter>
         <View maxWidth={'lg'}>
         <div
      dangerouslySetInnerHTML={{
        __html: `<a href="https://www.iubenda.com/termini-e-condizioni/96070560" class="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed" title="Termini e Condizioni">Termini e Condizioni</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>`
      }}
    />
         </View>
      </View>
   );
}
export default TermsAndConditionsPage
